import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from './user-auth.service';
import { environment } from '../environments/environment';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
	title = 'app';
	currentRoute: string;
	loggedIn: any; // this cascades down to SitemenuComponent and TopmenuComponent, to only display the menus to logged in users

	constructor(
		private router: Router,
		private userAuthService: UserAuthService,
	) { }

	/* check if logged in. if not, redirect to /login */
	isLoggedIn() {

		this.userAuthService.isLoggedIn().subscribe( 
			res => {
				if ( res.status == 200 ) {
					this.loggedIn = true;
				} else {
					this.loggedIn = false;
					this.router.navigate( ['login'] );
				}
			},
			error => {
				this.loggedIn = false;
				this.router.navigate( ['login'] );
			}
		);

	}

	ngOnInit() {

		/* when changing routes, check if logged in */
		this.router.events.subscribe(event =>
			{ 
				if ( event['url'] == '/logout' || event['url'] == '/forgot-password') {

					this.loggedIn = false;

				} else if ( event['url'] != this.currentRoute ) {

					this.currentRoute = event['url'];
					this.isLoggedIn();

				}
			}
		);

	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts